module.exports = __webpack_public_path__ + "static/img/productPartner_7_1.8ee3b27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/productPartner/productPartner_7_1.png
// module id = EWr5
// module chunks = 34